module.exports = __webpack_public_path__ + "static/media/reward11.eb8c5ae7.jpg";